import { render, staticRenderFns } from "./TaskOperations.vue?vue&type=template&id=487a0bac"
import script from "./TaskOperations.vue?vue&type=script&lang=js"
export * from "./TaskOperations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports